// Quem abre estas telas (TRI-107; o admin passa). Aplicado pelo guard de @/router/permissoes.js,
// que o menu lateral também usa.
const ROLES = ['triveni_compras']


const fornecedorBreadCrumb = [
  { label: 'Home', to: 'Home' },
  { label: 'Fornecedores', to: 'Fornecedores' }
]

export default [
  {
    path: '/fornecedores',
    name: 'Fornecedores',
    component: () => import('@/views/Fornecedor/FornecedorListPage.vue'),
    meta: {
      roles: ROLES,
      title: 'Fornecedores',
      breadcrumb: fornecedorBreadCrumb
    }
  },
  {
    path: '/fornecedores/novo',
    name: 'FornecedorNovo',
    component: () => import('@/views/Fornecedor/FornecedorPage.vue'),
    meta: {
      roles: ROLES,
      title: 'Novo Fornecedor',
      breadcrumb: [
        ...fornecedorBreadCrumb,
        { label: 'Novo Fornecedor', to: 'FornecedorNovo' }
      ]
    }
  },
  {
    path: '/fornecedores/:id/edit',
    name: 'FornecedorEdit',
    component: () => import('@/views/Fornecedor/FornecedorPage.vue'),
    meta: {
      roles: ROLES,
      title: 'Detalhes do Fornecedor',
      breadcrumb: [
        ...fornecedorBreadCrumb,
        { label: 'Detalhes', to: 'FornecedorEdit' }
      ]
    }
  }
]
